export var ParamEvent = /* @__PURE__ */ ((ParamEvent2) => {
  ParamEvent2["VISIBLE_UPDATED"] = "param_visible_updated";
  ParamEvent2["EDITABLE_UPDATED"] = "param_editable_updated";
  ParamEvent2["RAW_INPUT_UPDATED"] = "raw_input_updated";
  ParamEvent2["VALUE_UPDATED"] = "param_value_updated";
  ParamEvent2["EXPRESSION_UPDATED"] = "param_expression_update";
  ParamEvent2["ERROR_UPDATED"] = "param_error_updated";
  ParamEvent2["DELETED"] = "param_deleted";
  return ParamEvent2;
})(ParamEvent || {});
